import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-cards-recommender]')) return;
  addEventListeners();
}

function addEventListeners() {
  cardsRecommenderData();
  cardsRecommenderHeavyVehicles();
  cardsRecommenderLightVehicles();
  cardsRecommenderMixedVehicles();
}

function savePrefillFormConfigurable(data) {
  const storedData = JSON.parse(sessionStorage.getItem('prefillFormConfigurable') || '{}');
  const prefillFormConfigurable = { ...storedData };

  Object.entries(data).forEach(([key, value]) => {
    if (value === null) {
      delete prefillFormConfigurable[key];
    } else {
      prefillFormConfigurable[key] = value;
    }
  });

  sessionStorage.setItem('prefillFormConfigurable', JSON.stringify(prefillFormConfigurable));
}

function getControlTitle(control) {
  return control.querySelector('[data-au-segmented-control-title]')?.innerText.trim();
}

function getVehiclesAmount(content) {
  return Array.from(content.querySelectorAll('[data-au-recommender-input-vehicles] input')).reduce(
    (total, input) => total + (Number(input.value) || 0),
    0,
  );
}
/**
 * function to handle the data for the cards recommender tool
 * Used to manage and store user selections for the cards recommender tool. With this data, backend creates, in the final page, the correct form (with hidden fields that reflect the user's choices).
 */
function cardsRecommenderData() {
  $$('[data-au-cards-recommender] [data-au-segmented-control]').forEach((control) => {
    control.addEventListener('click', () => {
      const contentId = control.closest('[data-au-recommender-content]')?.dataset.auRecommenderContent;
      const title = getControlTitle(control);

      if (!title) return;
      if (contentId === 'start') {
        savePrefillFormConfigurable({
          VehicleType__c: title,
          NumberOfVehicles__c: 0,
          TrafficScope__c: null,
          NeedsCredit__c: null,
        });
      }
      if (contentId === 'heavy-vehicles-route' || contentId === 'mixed-vehicles-route') {
        savePrefillFormConfigurable({ TrafficScope__c: title });
      }
      if (contentId === 'credit') savePrefillFormConfigurable({ NeedsCredit__c: title });
    });
  });

  $$('[data-au-cards-recommender] [data-au-recommender-input-vehicles] input').forEach((input) => {
    input.addEventListener('input', () => {
      const content = input.closest('[data-au-recommender-content]');
      if (content) savePrefillFormConfigurable({ NumberOfVehicles__c: getVehiclesAmount(content) });
    });
  });
}

/**
 * Function to get data-au-recommender-final-url from the segmented control
 * and set the href of the button
 * depending on the selected card.
 * The button is the first element with data-au-recommender-button
 * inside the data-au-recommender-content div.
 */
function cardsRecommenderHeavyVehicles() {
  const cardRecommenderCard = $$('[data-au-recommender-content="heavy-vehicles-route"] [data-au-segmented-control]');

  cardRecommenderCard.forEach((card) => {
    card.addEventListener('click', (e) => {
      const target = e.currentTarget;
      const finalUrl = target.dataset.auRecommenderFinalUrl;
      const finalBtn = target.closest('[data-au-recommender-content]').querySelector('[data-au-recommender-button]');

      if (!finalBtn) return;
      finalBtn.setAttribute('href', finalUrl);
      finalBtn.classList.remove('disabled');
      finalBtn.removeAttribute('tabindex');
    });
  });
}

/**
 * Function to get data-au-recommender-urlA and data-au-recommender-urlB
 * from the segmented control and set the href of the button
 * depending on the total of light vehicles.
 */
function cardsRecommenderLightVehicles() {
  const inputs = $$('[data-au-recommender-content="light-vehicles"] input');
  const urlA = $('[data-au-segmented-control="co2-compensation-2"]').dataset.auRecommenderUrlA;
  const urlB = $('[data-au-segmented-control="co2-compensation-2"]').dataset.auRecommenderUrlB;

  function totalLightVehicles() {
    let total = 0;
    inputs.forEach((input) => {
      const value = input.valueAsNumber;
      if (!isNaN(value)) {
        total += value;
      }
    });

    const finalUrl = total > 100 ? urlA : urlB;
    $('[data-au-segmented-control="co2-compensation-2"] a').href = finalUrl;
  }

  inputs.forEach((input) => {
    input.addEventListener('input', totalLightVehicles);
  });
}

/**
 * Function to get data-au-recommender-urlA and data-au-recommender-urlB
 * from the segmented control and set the href of the button
 * depending on the total of light vehicles.
 */
function cardsRecommenderMixedVehicles() {
  const mixedInputs = $$('[data-au-recommender-content="mixed-vehicles"] input');
  let isCrt = false;

  function totalMixedVehicles() {
    let totalMixedVehiclesMinusTrucks = 0;
    const mixedTrucks = $('#cards-recommender-input-id-mixed-tanker-truck').valueAsNumber || 0;
    const urlNationalCrt = $('[data-au-segmented-control="mixed-vehicles-route-2"]').dataset.auRecommenderUrlA;
    const urlNationalFleet = $('[data-au-segmented-control="mixed-vehicles-route-2"]').dataset.auRecommenderUrlB;
    const urlInternationalCrt = $('[data-au-segmented-control="mixed-vehicles-route-1"]').dataset.auRecommenderUrlA;
    const urlInternationalFleet = $('[data-au-segmented-control="mixed-vehicles-route-1"]').dataset.auRecommenderUrlB;
    const nationalChecked = $('#mixed-vehicles-route-2')?.checked;
    const internationalChecked = $('#mixed-vehicles-route-1')?.checked;
    const finalBtn = $('[data-au-recommender-content="mixed-vehicles-route"] [data-au-recommender-button]');

    mixedInputs.forEach((input) => {
      if (input.id === 'cards-recommender-input-id-mixed-tanker-truck') return;
      const value = input.valueAsNumber;
      if (!isNaN(value)) {
        totalMixedVehiclesMinusTrucks += value;
      }
    });
    isCrt = totalMixedVehiclesMinusTrucks < mixedTrucks;

    if (isCrt) {
      if (nationalChecked) finalBtn.href = urlNationalCrt;
      if (internationalChecked) finalBtn.href = urlInternationalCrt;
    } else {
      if (nationalChecked) finalBtn.href = urlNationalFleet;
      if (internationalChecked) finalBtn.href = urlInternationalFleet;
    }
  }

  const mixedRouteType = $$('[data-au-recommender-content="mixed-vehicles-route"] [data-au-segmented-control]');
  mixedRouteType.forEach((segControl) => {
    segControl.addEventListener('click', (e) => {
      const input = e.currentTarget.querySelector('input');
      const urlA = input.closest('[data-au-segmented-control]').dataset.auRecommenderUrlA;
      const urlB = input.closest('[data-au-segmented-control]').dataset.auRecommenderUrlB;
      const finalBtn = input.closest('[data-au-recommender-content]').querySelector('[data-au-recommender-button]');

      if (!finalBtn) return;
      const finalUrl = isCrt ? urlA : urlB;
      finalBtn.href = finalUrl;
      finalBtn.classList.remove('disabled');
      finalBtn.removeAttribute('tabindex');
    });
  });

  mixedInputs.forEach((input) => {
    input.addEventListener('input', () => {
      totalMixedVehicles();
    });
  });

  totalMixedVehicles();
}

export default { init };
